import { PrimaryLinkButton } from '@pulse-web-ui/button-v2';
import { styled, typography } from '@pulse-web-ui/theme';

export const AlertText = styled.p`
  ${typography.regular16}
  margin-top: -4px;
  margin-bottom: 8px;
`;

export const AlertDescription = styled.p`
  ${typography.regular16}
  margin-bottom: 8px;
`;

export const ContractConclusionStoppedAlertButton = styled(PrimaryLinkButton)`
  width: auto;
`;
